import { actionSet } from './utils'

import firebase from 'utils/Firebase'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from './spinner'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_LOGO_BRANDS_SUCCESS,
  FETCH_LOGO_BRANDS_ERROR,
  SAVE_LOGO_BRANDS_SUCCESS,
  SAVE_LOGO_BRANDS_ERROR,
  DELETE_LOGO_BRANDS_SUCCESS,
  DELETE_LOGO_BRANDS_ERROR,
  GET_PAGES,
  GET_LOGO_BRANDS_SUCCESS,
} from 'actionTypes'

const FOLDER = 'brands_for_datasheets'

const FILE_NAME_PREFIX = 'logo_'

export const fetchLogoBrands = (token, filter, page, counter) => (dispatch) =>
  new Api(token, dispatch)
    .post(`${API_URL.FETCH_LOGO_BRANDS}?size=10&page=${page}`, filter)
    .then(
      (response) => {
        dispatch(getPages(response.data.pages, GET_PAGES, counter))
        dispatch(fetchLogoBrandsSuccess(response.data.resultList, counter))
      },
      (error) => {
        dispatch(actionSet(FETCH_LOGO_BRANDS_ERROR, error))
      }
    )
    .finally(() => dispatch(hideSpinner()))

export const fetchLogoBrandsSuccess = (data, counter) => ({
  type: FETCH_LOGO_BRANDS_SUCCESS,
  payload: data,
  counter,
})

export const getLogoBrands = (token, filter) => (dispatch) =>
  new Api(token, dispatch)
    .post(`${API_URL.FETCH_LOGO_BRANDS}?size=50&page=1`, filter)
    .then(
      (response) => {
        dispatch(actionSet(GET_LOGO_BRANDS_SUCCESS, response.data.resultList))
      },
      (error) => {
        dispatch(actionSet(FETCH_LOGO_BRANDS_ERROR, error))
      }
    )

export const saveLogoBrands =
  (token, params, onSuccessCallback, filter, page) => async (dispatch) => {
    dispatch(showSpinner())

    const brandName = params.nmBrand.value

    const fileName = params.logo.name

    const newFileName =
      FILE_NAME_PREFIX +
      brandName +
      fileName.substring(fileName.lastIndexOf('.'))

    const uploadTask = firebase
      .storage()
      .ref()
      .child(FOLDER)
      .child(newFileName)
      .put(params.logo.fileToUpload)

    try {
      const fileUrl = await new Promise((resolve, reject) =>
        uploadTask.on(
          firebase.storage.TaskEvent.STATE_CHANGED,
          () => {},
          (error) => reject(error),
          () => resolve(uploadTask.snapshot.ref.getDownloadURL())
        )
      )

      const paramsToSave = { nmBrand: brandName, dsLinkLogo: fileUrl }

      await new Api(token, dispatch).post(
        API_URL.SAVE_LOGO_BRANDS,
        paramsToSave
      )

      dispatch(actionSet(SAVE_LOGO_BRANDS_SUCCESS))

      onSuccessCallback()

      dispatch(fetchLogoBrands(token, filter, page))
    } catch (error) {
      dispatch(actionSet(SAVE_LOGO_BRANDS_ERROR, error))
    } finally {
      dispatch(hideSpinner())
    }
  }

export const deleteLogoBrands =
  (token, params, onSuccessCallback, filter, page) => async (dispatch) => {
    dispatch(showSpinner())

    try {
      await firebase.storage().refFromURL(params.dsLinkLogo).delete()

      await new Api(token, dispatch).post(API_URL.DELETE_LOGO_BRANDS, params)

      dispatch(actionSet(DELETE_LOGO_BRANDS_SUCCESS))

      onSuccessCallback('')

      dispatch(fetchLogoBrands(token, filter, page))
    } catch (error) {
      dispatch(actionSet(DELETE_LOGO_BRANDS_ERROR, error))
    } finally {
      dispatch(hideSpinner())
    }
  }
